<template>
  <div>
    <h3>Movie Times &amp; Tickets</h3>
  </div>
</template>
<script>
  export default {
    name: 'movie-times-and-tickets',
    data() {
      return {

      }
    },
    mounted() {
      this.$root.$firebaseRefs.anObject.once('value', function(snapshot) {
        window.console.log(snapshot.val())
      })
    }
  }
</script>



// WEBPACK FOOTER //
// MovieTimesAndTickets.vue?501901a2